module.exports = __webpack_public_path__ + "img/wild_beer.70901401.jpg";